import {IItemContent} from "@connox/typescript-library";
import React, {Suspense, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import {useTranslation} from "react-i18next";
import ErrorBoundary from "../../utils/ErrorBoundary";
import SwiperConstruct from "../crossSelling/SwiperConstruct";
import window from "../../lib/WindowExtended";
import {getShopId} from "../../lib/getShopId";
import {useCustomerSelector} from "../../../store";
import ListItemCard from "./ListItemCard";

// Neu bei Connox module;
const NewProductsPortalComponent: React.FC<{element: HTMLElement}> = ({element}) => {
  const {t} = useTranslation();
  const linkUrl = element.dataset.containerLinkUrl;
  const {customerId, customerGroupId, token} = useCustomerSelector().customer;
  const itemIds = element.dataset.newItemIds;
  const [items, setItems] = useState<IItemContent[]>([]);

  useEffect(() => {
    if (itemIds === undefined) {
      return;
    }

    const customerParams = [`currencyCode=${window.c_ActiveCurrency}`];

    if (customerId) {
      customerParams.push(`customerId=${customerId}`);
    }

    if (customerGroupId) {
      customerParams.push(`customerGroupId=${customerGroupId}`);
    }

    const customerParamsString = customerParams.join("&");
    const internalUrl = `${__API_URL__}/${getShopId()}/items?view=content&itemIds=${encodeURIComponent(itemIds)}&${customerParamsString}`;
    const headers: HeadersInit = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    void fetch(internalUrl, {headers})
      .then((res) => res.json() as Promise<{result: IItemContent[]}>)
      .then((data) => {
        if (data.result.length) {
          setItems(data.result);
        } else {
          element.parentElement?.remove();
        }
      });
  }, []);

  if (!items.length) {
    return null;
  }

  return (
    <SwiperConstruct
      title={t("product.newProductsAtConnox")}
      link={
        linkUrl && (
          <a href={linkUrl} className={"link link-icon ml-0 ml-m-3"}>
            {t("product.showAllNewProducts")}
            <i className="icon icon-right--blue ml-3"></i>
          </a>
        )
      }
    >
      {items.map((item, key) => {
        return <ListItemCard key={key} item={item}/>;
      })}
    </SwiperConstruct>
  );
};

const NewProductsPortal: React.FC = () => {
  const sectionDivElement = document.getElementById("NewProductsSlider");

  if (!sectionDivElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <ErrorBoundary fallback={null} occurrence="NewProductsPortal">
      <Suspense fallback={null}>
        <NewProductsPortalComponent element={sectionDivElement} />
      </Suspense>
    </ErrorBoundary>,
    sectionDivElement,
  );
};

export default NewProductsPortal;
